import React, { useState } from 'react';

import { inject, observer } from 'mobx-react';
import { DynamicFormModal } from '@bringg-frontend/dynamic-form-modal';
import { useHasFeatureFlag } from '@bringg-frontend/hooks';

import { Button, Link } from '../../../components';
import { Translate } from '../../../translation';
import UserTypeStore from '../../../stores/user-type/user-type-store';
import formFields from './user-types-columns';
import UserType from '../../../stores/user-type/domain-objects/user-type';
import { UserTypeModal } from '../user-type-modal/user-type-modal';
import { useUserTypeModal } from '../user-type-modal-context';

interface Props {
	userTypeStore?: UserTypeStore;
}

const UserTypesHeader = ({ userTypeStore }: Props) => {
	const useNewUserTypeModal = useHasFeatureFlag('enable_route_cost_calculation');

	const {
		openCreateModal,
		modalConfig: { isOpen }
	} = useUserTypeModal();
	const [isLegacyModalVisible, setIsLegacyModalVisible] = useState(false);

	const toggleLegacyModal = () => setIsLegacyModalVisible(!isLegacyModalVisible);

	const saveLegacyUserType = async (userType: any) => {
		const newUserType = new UserType(userType, userTypeStore);
		await newUserType.create();
	};

	const handleAddClick = useNewUserTypeModal ? openCreateModal : toggleLegacyModal;

	return (
		<div className="user-types-header">
			<Button onClick={handleAddClick} className="add-user-type">
				<Translate text="USER_TYPE.ADD" />
			</Button>

			<Button className="back-to-drivers">
				<Link to="/drivers/">
					<Translate text="USER_TYPE.DRIVERS" />
				</Link>
			</Button>

			{useNewUserTypeModal ? (
				isOpen ? (
					<UserTypeModal />
				) : null
			) : (
				<DynamicFormModal
					className="create-user-types-modal"
					visible={isLegacyModalVisible}
					title={<Translate text="USER_TYPE.CREATE_MODAL_TITLE" />}
					okText={(<Translate text="USER_TYPE.SUBMIT_MODAL_BTN" />) as any}
					cancelText={(<Translate text="USER_TYPE.CANCEL" />) as any}
					onClose={toggleLegacyModal}
					onSubmit={saveLegacyUserType}
					formFields={formFields()}
					numberOfColumns={1}
					layout="horizontal"
					destroyOnClose
				/>
			)}
		</div>
	);
};

export default inject('userTypeStore')(observer(UserTypesHeader));
